import { useCallback } from 'react'
import WindowIpcRenderer from '@renderer/ipc/WindowIpc.renderer'
import { useSetSidepanelState } from '@renderer/overlay/atoms'

export function useOpenSettingsTab() {
  const setSidepanelState = useSetSidepanelState()

  return useCallback(
    (tab: string) => {
      setSidepanelState('hidden')
      // Routing to the tab is enough: a fresh window loads this hash route, and
      // an already-open one is re-navigated via `deeplink-received`.
      void WindowIpcRenderer.openSettingsWindow(`/settings/${tab}`)
    },
    [setSidepanelState],
  )
}
